<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mKOxZi/tc-custom/9781982113308.jpg?1730534220335" alt="This image is the cover for the book Captain's Oath, Star Trek: The Original Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Captain's Oath, Star Trek: The Original Series
      </h1>
      <p class="bookDescription body article font2">
        <b>An all-new <i>Star Trek </i>adventure set during <i>The Original Series</i> era and featuring James T. Kirk! </b><br/><br/>The saga of James T. Kirk’s historic command of the <i>U.S.S. Enterprise </i>is known throughout the galaxy. But one part of the legend has barely been touched upon until now: the story of Kirk’s first starship command and the remarkable achievements by which Starfleet’s youngest captain earned the right to succeed Christopher Pike as the commander of the famous <i>Enterprise</i>. From his early battles with the Klingons to the rescue of endangered civilizations, Kirk grapples with difficult questions: Is he a warrior or a peacemaker? Should he obey regulations or trust his instincts? This thrilling novel illustrates the events and choices that would shape James T. Kirk into one of the most renowned captains in Starfleet history.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher L. Bennett
      </h2>
      
      <p class="authorDescription body article">Christopher L. Bennett is a lifelong resident of Cincinnati, Ohio, with bachelor&rsquo;s degrees in physics and history from the University of Cincinnati. He has written such critically acclaimed&#160;<I>Star Trek</I>&#160;novels as&#160;<I>Ex&#160;Machina, The Buried Age,</I>&#160;the Titan novels&#160;<I>Orion&rsquo;s Hounds</I>&#160;and&#160;<I>Over a Torrent Sea</I>, the two Department of Temporal Investigations novels&#160;<I>Watching the Clock</I>&#160;and<I>&#160;Forgotten History</I>, and the Enterprise novels&#160;<I>Rise of the Federation: A Choice of Futures</I>,<I>&#160;Tower of Babel</I>,&#160;<I>Uncertain Logic</I>, and&#160;<I>Live By the Code</I>, as well as shorter works including stories in the anniversary anthologies&#160;<I>Constellations, The Sky&rsquo;s the Limit, Prophecy</I>&#160;and&#160;<I>Change</I>, and<I>&#160;Distant Shores</I>. Beyond Star Trek, he has penned the novels&#160;<I>X Men: Watchers on the Walls&#160;</I>and&#160;<I>Spider Man: Drowned in Thunder</I>. His original work includes the hard science fiction superhero novel&#160;<I>Only Superhuman</I>, as well as several novelettes in&#160;<I>Analog</I>&#160;and other science fiction magazines.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e35641e